import { RiEdit2Fill } from "react-icons/ri";
import { useState } from "react";
import { HiTrash } from "react-icons/hi";
import useSession from "../../hooks/useSession";

const statusColor = (status) => {
  switch (status) {
    case "active":
      return "bg-green-200 text-green-600";
    case "inactive":
      return "bg-red-200 text-red-600";
    default:
      return "bg-gray-200 text-gray-600";
  }
};

function UserTableRow({ item, handleUserEdit, handleSingleDelete, no }) {
  const [visibility, setVisibility] = useState(true);
  const [user] = useSession();

  const handleDelete = async () => {
    const res = await handleSingleDelete(item._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility ? (
        <tr key={item._id}>
          <td className="px-6 py-4 text-base font-medium text-gray-800 whitespace-nowrap">
            {no}
          </td>
          <td className="px-6 py-4 text-base text-gray-800 whitespace-nowrap">
            {item.name}
          </td>
          <td className="px-6 py-4 text-base text-gray-800 whitespace-nowrap">
            {item.email}
          </td>
          <td className="px-6 py-4 text-base text-gray-800 whitespace-nowrap">
            {item.role}
          </td>
          <td className="px-6 py-4 text-base text-gray-800 whitespace-nowrap">
            <span
              className={`${statusColor(
                item.status
              )} p-2 px-4 rounded-full font-semibold`}
            >
              {item.status}
            </span>
          </td>
          <td className="px-6 py-4 text-base text-gray-800 whitespace-nowrap">
            {item?.updatedAt &&
              new Intl.DateTimeFormat(["ban", "id"]).format(
                new Date(item?.updatedAt)
              )}
          </td>
          <td className="px-6 py-4 text-base text-gray-800 whitespace-nowrap">
            {item?.createdAt &&
              new Intl.DateTimeFormat(["ban", "id"]).format(
                new Date(item?.createdAt)
              )}
          </td>
          <td className="px-6 py-4 text-xl md:text-base font-medium text-right whitespace-nowrap">
            <button
              // disabled={item.primary === "true"}
              onClick={() => handleUserEdit(item)}
              className={`${
                item.primary === "true" ? "hidden" : ""
              } bg-green-600 rounded-full text-white hover:shadow-lg px-3 md:px-4 py-2 md:py-2 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:shadow-none`}
            >
              <RiEdit2Fill className="inline md:mr-1 mb-1" />{" "}
              <span className="hidden lg:inline-block">Edit</span>
            </button>
          </td>
          <td className="px-6 py-4 text-xl md:text-base font-medium text-right whitespace-nowrap">
            <button
              disabled={user.role !== "admin"}
              onClick={handleDelete}
              className={`${
                item.primary === "true" ? "hidden" : ""
              } bg-red-500 text-white hover:shadow-lg rounded-full px-3 md:px-4 py-2 md:py-2 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:shadow-none`}
            >
              <HiTrash className="inline md:mr-1 mb-1" />
              <span className="hidden lg:inline-block">Delete</span>
            </button>
          </td>
        </tr>
      ) : null}
    </>
  );
}

export default UserTableRow;
